export default __webpack_public_path__ + "static/media/akshit.66a2e64f.png";